var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPath({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "21px",
    viewBox: "0 0 16 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "72819DAE-CC7A-4C0C-B193-C8F430D6F6E1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Master-Landing-/-Compliance",
    transform: "translate(-21.000000, -699.000000)",
    fill: "#E7D78B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bookmark",
    transform: "translate(21.581464, 699.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6260251,0 L1.80765843,0 C0.845136511,0 0,0.791823172 0,1.72908129 L0,19.2120144 C0,19.5257465 0.0873186052,19.7872221 0.22804661,19.9892364 C0.396343856,20.2307314 0.667329319,20.369154 0.957911036,20.369154 C1.23264284,20.369154 1.52514576,20.2467734 1.79526668,20.0160372 L7.08279727,15.5266697 C7.24609939,15.3871905 7.48067809,15.3072685 7.72457461,15.3072685 C7.96837507,15.3072685 8.20247347,15.3871905 8.36625589,15.5270539 L13.6361114,20.0153647 C13.907193,20.2467734 14.1795233,20.369154 14.4537748,20.369154 C14.9175528,20.369154 15.3696115,20.0114263 15.3696115,19.2121104 L15.3696115,1.72908129 C15.3696115,0.791823172 14.588547,0 13.6260251,0 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath);
export default __webpack_public_path__ + "static/media/Path.82190b88c6fbe5a6fd571796bb99d3c1.svg";
export { ForwardRef as ReactComponent };